import React, { useRef } from "react";
import { ICustomer } from "../../interfaces/ICustomer";
import { Button } from "@mui/material";
import vCardParser from "vcard-parser";
import { getEmptyCustomer } from "./CustomerEdit";
import { IPostcode } from "../../interfaces/IPostcode";
import { getFetchPromise } from "../../hooks/useFetch";

interface IProps {
    handleReturnCustomer: (updatedCustomer: ICustomer) => void;
    setIsAddCustomerOpen: Function;
    buttonTitle: string;
}

export const CustomerFromVCard: React.FC<IProps> = ({ handleReturnCustomer, setIsAddCustomerOpen, buttonTitle }) => {
    const inputUpload = useRef<HTMLInputElement | null>(null);

    const parseVCardToCustomer = async (card: any): Promise<ICustomer> => {
        console.log(card);
        const currentContact = getEmptyCustomer();

        // Name
        const n = card.n?.[0]?.["value"];
        currentContact.lastname = n[0];
        currentContact.firstname = n[1];

        // Email
        currentContact.email = card.email?.[0]?.value || "";

        // Telefon / Mobil
        if (card.tel) {
            const homeTel = card.tel.find((t: any) => t.meta?.type?.includes("HOME"));
            const workTel = card.tel.find((t: any) => t.meta?.type?.includes("WORK"));
            const cellTel = card.tel.find((t: any) => t.meta?.type?.includes("CELL"));

            currentContact.telefon = homeTel?.value || workTel?.value || "";
            currentContact.mobil = cellTel?.value || "";
        }

        // Adresse
        const adr = card.adr?.[0]?.["value"];

        const streetFull = adr[2];
        const city = adr[3];
        const postcode = adr[5];
        const country = adr[6];

        if (currentContact.Address) {
            const streetMatch = streetFull.match(/^(.+?)\s+(\d+[a-zA-Z]?)$/);
            if (streetMatch) {
                currentContact.Address.street = streetMatch[1];
                currentContact.Address.street_number = streetMatch[2];
            } else {
                currentContact.Address.street = streetFull;
                currentContact.Address.street_number = "";
            }

            if (postcode && city) {
                try {
                    const matchingPostcodes = await getFetchPromise<IPostcode[]>(`/postcode/search/${postcode}`);
                    const matchedPostcode = matchingPostcodes.find(
                        (p) =>
                            p.postcode === postcode &&
                            (city.toLowerCase().includes(p.city.toLowerCase()) ||
                                p.city.toLowerCase().includes(city.toLowerCase())),
                    );
                    if (matchedPostcode) {
                        currentContact.Address.Postcode = matchedPostcode.id;
                    }
                } catch (err) {
                    console.error("Postleitzahl konnte nicht geladen werden:", err);
                }
            }
        }

        return currentContact;
    };

    const castToCustomer = async (acceptedFiles: File[]) => {
        if (acceptedFiles.length !== 1) return;

        const file = acceptedFiles[0];
        const resultText = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsText(file);
        });

        try {
            console.log(resultText);
            const parsedCards = vCardParser.parse(resultText);
            console.log(parsedCards);
            if (parsedCards.length === 0) throw new Error("Keine vCard gefunden.");
            const customer = await parseVCardToCustomer(parsedCards);
            handleReturnCustomer(customer);
        } catch (error) {
            console.error("vCard Parse Error:", error);
        }
    };

    const handleNormalUpload = (files: null | FileList) => {
        if (files) {
            const acceptedFiles = Array.from(files);
            castToCustomer(acceptedFiles);
        }
    };

    return (
        <>
            <Button
                variant="outlined"
                sx={{ float: "right", mr: 2 }}
                onClick={() => {
                    setIsAddCustomerOpen(false);
                    inputUpload.current?.click();
                }}
            >
                {buttonTitle}
            </Button>

            <input
                hidden
                ref={inputUpload}
                type="file"
                accept=".vcf,text/vcard"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleNormalUpload(e.target.files);
                }}
            />
        </>
    );
};
